import { useEffect, useMemo, useRef, useState } from "react";
import { FaPlaneArrival, FaPlaneDeparture } from "react-icons/fa";
import { IoAirplaneSharp } from "react-icons/io5";

export const CloudOffIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
    <path
      d="M8.5 17.5h9.2a4.3 4.3 0 0 0 1.1-8.5 6.4 6.4 0 0 0-11.9-2.1A4.7 4.7 0 0 0 8.5 17.5Z"
      fill="currentColor"
      opacity="0.9"
    />
    <path
      d="M4 4 20 20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const PinIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
    <path
      d="M12 21s6-4.2 6-10a6 6 0 1 0-12 0c0 5.8 6 10 6 10Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M12 12.2a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2Z"
      fill="currentColor"
      opacity="0.9"
    />
  </svg>
);

export const BellIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
    <path
      d="M18 10a6 6 0 1 0-12 0c0 6-2 6.5-2 6.5h16S18 16 18 10Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M12 22a2.2 2.2 0 0 0 2.2-2.2H9.8A2.2 2.2 0 0 0 12 22Z"
      fill="currentColor"
      opacity="0.9"
    />
    <path
      d="M12 4V2.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const Icon = ({ name, className = "" }) => {
  const base = "h-5 w-5";
  switch (name) {
    case "plane-depart":
        return (
        <FaPlaneDeparture className={`${base} ${className}`} />
        );
    case "plane-arrive":
        return (
        <FaPlaneArrival className={`${base} ${className}`} />
        );
    case "plane-cruise":
        return(
            <IoAirplaneSharp className={`${base} ${className}`} />
        )
    case "x":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M7 7l10 10M17 7 7 17"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
          />
        </svg>
      );
    case "calendarEdit":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M7 3v3M17 3v3"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M5 7.5h14A2 2 0 0 1 21 9.5v10A2 2 0 0 1 19 21.5H5A2 2 0 0 1 3 19.5v-10A2 2 0 0 1 5 7.5Z"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="M8 12h5"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            opacity="0.7"
          />
          <path
            d="M14.5 14.5 18.7 10.3a1.4 1.4 0 0 1 2 2l-4.2 4.2-2.6.6.6-2.6Z"
            fill="currentColor"
            opacity="0.95"
          />
        </svg>
      );
    case "grid":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none" aria-hidden="true">
          <path d="M4 4h7v7H4V4Zm9 0h7v7h-7V4ZM4 13h7v7H4v-7Zm9 0h7v7h-7v-7Z" fill="currentColor" opacity="0.9" />
        </svg>
      );
    case "list":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none" aria-hidden="true">
          <path d="M7 6h14M7 12h14M7 18h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M4 6h.01M4 12h.01M4 18h.01" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
        </svg>
      );
    case "pin":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none" aria-hidden="true">
          <path d="M12 21s6-4.2 6-10a6 6 0 1 0-12 0c0 5.8 6 10 6 10Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
          <path d="M12 12.2a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2Z" fill="currentColor" opacity="0.9" />
        </svg>
      );
    case "bag":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none" aria-hidden="true">
          <path d="M7 8V7a5 5 0 0 1 10 0v1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M6.5 8.5h11l-1 12h-9l-1-12Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        </svg>
      );
    case "plus":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M12 5v14M5 12h14"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      );
    case "trash":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M9 3h6m-8 4h10m-9 0 1 14h6l1-14"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 11v7M14 11v7"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      );
    case "calendar":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M7 3v3M17 3v3"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M4.5 8.5h15"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M6.5 5.5h11A2 2 0 0 1 19.5 7.5v12A2 2 0 0 1 17.5 21.5h-11A2 2 0 0 1 4.5 19.5v-12A2 2 0 0 1 6.5 5.5Z"
            stroke="currentColor"
            strokeWidth="1.6"
          />
        </svg>
      );
    case "check":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M20 7 10.5 16.5 4 10"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "arrow":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M5 12h12"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M13 6l6 6-6 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "plane":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M3 11.5 21 7.5l-6.5 7.2"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 11.5l7 3.2 2.2 6.3 2.4-2.4-.9-4.4 5.8-6.7"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "badge":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M8 3.5h8l2 3v14a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 20.5v-14l2-3Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
          />
          <path
            d="M9 11h6"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            opacity="0.7"
          />
        </svg>
      );
    case "depart":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M3 12h10"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M13 12 21 8.5l-3.1 5.1L21 18l-8-3.4"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M4 18h6"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            opacity="0.6"
          />
        </svg>
      );
    case "arrive":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M3 12h10"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M13 12 21 15.5l-3.1-5.1L21 6l-8 3.4"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M4 18h14"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            opacity="0.6"
          />
        </svg>
      );
    case "users":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M16 11a3 3 0 1 0-3-3 3 3 0 0 0 3 3ZM8 12a2.6 2.6 0 1 0-2.6-2.6A2.6 2.6 0 0 0 8 12Z"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <path
            d="M20.2 20a5 5 0 0 0-8.4-3.5M12.5 20a6 6 0 0 0-10 0"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </svg>
    );
    case "lock":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M7.5 11V8.8A4.5 4.5 0 0 1 12 4.3a4.5 4.5 0 0 1 4.5 4.5V11"
            stroke="currentColor"
            strokeWidth="1.9"
            strokeLinecap="round"
          />
          <path
            d="M7 11h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2Z"
            fill="currentColor"
            opacity="0.95"
          />
        </svg>
      );
    case "shield":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M12 2.7 20 6.2V12c0 5.2-3.4 9.2-8 10.9C7.4 21.2 4 17.2 4 12V6.2l8-3.5Z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinejoin="round"
          />
          <path
            d="M9.2 12.2 11.3 14.3 15.6 10"
            stroke="currentColor"
            strokeWidth="1.9"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "checkBadge":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M12 21s7-3.5 7-10V6.2L12 3 5 6.2V11c0 6.5 7 10 7 10Z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinejoin="round"
          />
          <path
            d="M9.5 12.2 11.4 14.1 15.8 9.7"
            stroke="currentColor"
            strokeWidth="1.9"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "card":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M4 7.5h16A2 2 0 0 1 22 9.5v8A2 2 0 0 1 20 19.5H4A2 2 0 0 1 2 17.5v-8A2 2 0 0 1 4 7.5Z"
            stroke="currentColor"
            strokeWidth="1.7"
          />
          <path
            d="M2 11h20"
            stroke="currentColor"
            strokeWidth="1.7"
            opacity="0.8"
          />
        </svg>
      );
    case "wallet":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M5 7.5h13a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3Z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinejoin="round"
          />
          <path
            d="M18.5 12.2h2.5v3h-2.5a1.5 1.5 0 0 1 0-3Z"
            fill="currentColor"
            opacity="0.9"
          />
        </svg>
      );
    case "chevL":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M14.5 6 9 12l5.5 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "chevR":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none">
          <path
            d="M9.5 6 15 12l-5.5 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "dot":
      return (
        <svg viewBox="0 0 10 10" className={`${className}`} fill="none">
          <circle cx="5" cy="5" r="4" fill="currentColor" />
        </svg>
      );
    case "download":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none" aria-hidden="true">
          <path d="M12 3v10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M8 11.5 12 15.5l4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M5 20h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case "edit":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none" aria-hidden="true">
          <path
            d="M4 20h4l10.5-10.5a2 2 0 0 0 0-2.8l-.2-.2a2 2 0 0 0-2.8 0L5 16v4Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path d="M13.5 6.5 17.5 10.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "share":
      return (
        <svg viewBox="0 0 24 24" className={`${base} ${className}`} fill="none" aria-hidden="true">
          <path
            d="M16 8a3 3 0 1 0-2.9-3.6"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M6 14a3 3 0 1 0 2.9 3.6"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M18 14a3 3 0 1 0-2.7 1.7"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M8.7 16.2 15.3 12.8M15.3 11.2 8.7 7.8"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    default:
      return null;
  }
};

export const GoldPill = ({ children }) => (
  <span className="inline-flex items-center rounded-full border border-[#d8b05a]/30 bg-[#d8b05a]/15 px-2 py-0.5 text-[10px] font-semibold tracking-widest text-[#d8b05a]">
    {children}
  </span>
);

export const Label = ({ children }) => (
  <div className="mb-2 text-[11px] tracking-[0.22em] text-white/40">{children}</div>
);

export const TextInput = ({ label, placeholder, value, onChange }) => (
  <label className="block min-w-0">
    <Label>{label}</Label>
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={[
        "w-full rounded-xl border border-white/10 bg-black/40 px-4 py-3",
        "text-sm text-white/80 placeholder:text-white/25 outline-none",
        "focus:border-[#d8b05a]/45 focus:ring-4 focus:ring-[#d8b05a]/10",
      ].join(" ")}
    />
  </label>
);

export const DateInput = ({ label, value, onChange }) => (
  <label className="block min-w-0">
    <Label>{label}</Label>
    <div className="relative">
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={[
          "w-full rounded-xl border border-white/10 bg-black/40 px-4 py-3 pr-10",
          "text-sm text-white/80 outline-none",
          "focus:border-[#d8b05a]/50 focus:ring-4 focus:ring-[#d8b05a]/10",
        ].join(" ")}
      />
      <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-white/40">
        <Icon name="calendar" />
      </span>
    </div>
  </label>
);

export const Feature = ({ children }) => (
  <div className="flex items-start gap-2 text-sm text-white/70">
    <span className="mt-0.5 grid h-5 w-5 place-items-center rounded-full bg-[#d8b05a]/15 text-[#d8b05a]">
      <Icon name="check" className="h-4 w-4" />
    </span>
    <span className="leading-6">{children}</span>
  </div>
);

export const FareCard = ({ title, subtitle, price, tag, selected, onClick, features }) => (
  <button
    type="button"
    onClick={onClick}
    className={[
      "relative w-full text-left overflow-hidden rounded-2xl border p-5 transition",
      selected
        ? "border-2 border-[#C59F59] bg-[#C59F59]/10"
        : "border-white/10 bg-white/5 hover:bg-white/7",
      "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/10",
    ].join(" ")}
  >
    <div className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <div className="flex items-center gap-3">
          <div className="text-lg font-semibold text-white/90">{title}</div>
          {tag ? <GoldPill>{tag}</GoldPill> : null}
        </div>
        <div className="mt-1 text-sm text-white/50">{subtitle}</div>
      </div>

      <div className="text-right">
        <div className="text-xl font-semibold text-[#d8b05a]">{price}</div>
        <div className="mt-1 text-[10px] tracking-[0.22em] text-white/30">All Inclusive</div>
      </div>
    </div>

    <div className="mt-4 h-px w-full bg-white/10" />

    <div className="mt-4 space-y-3">
      {features?.map((f, i) => (
        <Feature key={i}>{f}</Feature>
      ))}
    </div>

    {/* selection dot */}
    <div
      className={[
        "absolute right-5 top-5 h-4 w-4 rounded-full border",
        selected ? "border-[#d8b05a] bg-[#d8b05a]" : "border-white/20 bg-white/5",
      ].join(" ")}
    />
  </button>
);

function useDebouncedValue(value, delay = 150) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

/** normalize for search */
function norm(s) {
  return (s || "").toLowerCase().trim();
}

const AirportOption = ({ airport, active, onMouseDown }) => {
  const title = `${airport.city} (${airport?.iata}) • ${airport.country}`;
  const sub = `${airport.name}`;
  return (
    <li
      onMouseDown={onMouseDown} // use mousedown so it selects before blur
      className={[
        "cursor-pointer rounded-lg px-3 py-2",
        active ? "bg-white/10" : "hover:bg-white/5",
      ].join(" ")}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="truncate text-sm font-semibold text-[#1E1A14]">{title}</div>
          <div className="truncate text-xs text-[#1E1A14]/70">{sub}</div>
        </div>
        {/* <div className="shrink-0 text-xs font-semibold tracking-widest text-[#d8b05a]/90">
          {airport.iata}
        </div> */}
      </div>
    </li>
  );
};

export const AirportField = ({
  label,
  icon,
  airports,
  value,
  onChange,
  placeholder = "Search airport...",
  Icon,
}) => {
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);

  // what user types
  const [query, setQuery] = useState(value ? `${value?.city}, ${value?.iata}` : "");
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);

  // keep input in sync when parent changes selected value
  useEffect(() => {
    if (value) setQuery(`${value?.city}, ${value?.iata}`);
  }, [value]);

  // debounce query so filtering isn't too aggressive
  const debounced = useDebouncedValue(query, 120);

  const filtered = useMemo(() => {
    const q = norm(debounced);
    if (!q) return airports.slice(0, 8);

    const ranked = airports
      .map((a) => {
        const hay = norm(`${a.city} ${a.country} ${a.name} ${a?.iata} ${a.icao}`);
        // rank: startsWith IATA/city higher
        let score = 0;
        if (norm(a?.iata) === q) score += 100;
        if (norm(a.city).startsWith(q)) score += 40;
        if (norm(a.name).includes(q)) score += 25;
        if (hay.includes(q)) score += 10;
        return { a, score };
      })
      .filter((x) => x.score > 0)
      .sort((x, y) => y.score - x.score)
      .slice(0, 8)
      .map((x) => x.a);

    return ranked;
  }, [airports, debounced]);

  // close on outside click
  useEffect(() => {
    const onDocDown = (e) => {
      if (!wrapperRef.current) return;
      if (!wrapperRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocDown);
    return () => document.removeEventListener("mousedown", onDocDown);
  }, []);

  const selectAirport = (airport) => {
    onChange?.(airport);
    setQuery(`${airport.city}, ${airport?.iata}`);
    setOpen(false);
    setActiveIndex(-1);
  };

  const clearSelectionIfEditing = (nextValue) => {
    // if user starts typing something else, clear selected value in parent
    if (value) onChange?.(null);
    setQuery(nextValue);
  };

  const onKeyDown = (e) => {
    if (!open && (e.key === "ArrowDown" || e.key === "Enter")) {
      setOpen(true);
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setOpen(true);
      setActiveIndex((i) => Math.min(i + 1, filtered.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((i) => Math.max(i - 1, 0));
    } else if (e.key === "Enter") {
      if (open && activeIndex >= 0 && filtered[activeIndex]) {
        e.preventDefault();
        selectAirport(filtered[activeIndex]);
      }
    } else if (e.key === "Escape") {
      setOpen(false);
      setActiveIndex(-1);
    }
  };

  return (
    <div className="min-w-0" ref={wrapperRef}>
      <div className="mb-2 text-[11px] tracking-[0.22em] text-white/50">{label}</div>

      <div className="relative">
        <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-[#2E281F] px-4 py-3">
          {Icon ? <Icon name={icon} className="text-white/50" /> : null}

          <input
            ref={inputRef}
            value={query}
            onChange={(e) => {
              clearSelectionIfEditing(e.target.value);
              setOpen(true);
            }}
            onFocus={() => setOpen(true)}
            onKeyDown={onKeyDown}
            className="w-full min-w-0 bg-transparent text-sm text-white/70 placeholder:text-white/25 outline-none"
            placeholder={placeholder}
            autoComplete="off"
          />

          {query?.length > 0 && (
            <button
              type="button"
              onClick={() => {
                onChange?.(null);
                setQuery("");
                setOpen(true);
                inputRef.current?.focus();
              }}
              className="rounded-lg px-2 py-1 text-xs text-white/40 hover:text-white/70"
              aria-label="Clear"
            >
              ✕
            </button>
          )}
        </div>

        {/* Dropdown */}
        {open && filtered.length > 0 && (
          <div className="fixed z-50 mt-2 overflow-hidden rounded-2xl border border-white/10 bg-[#d8b05a] shadow-2xl">
            <ul className="max-h-64 overflow-auto p-2">
              {filtered.map((a, idx) => (
                <AirportOption
                  key={`${a?.iata}-${a.icao || idx}`}
                  airport={a}
                  active={idx === activeIndex}
                  onMouseDown={() => selectAirport(a)}
                />
              ))}
            </ul>
          </div>
        )}

        {open && filtered.length === 0 && (
          <div className="fixed z-50 mt-2 rounded-2xl border border-white/10 bg-[#d8b05a] p-3 text-sm text-[#1E1A14]">
            No airports found.
          </div>
        )}
      </div>
    </div>
  );
};

export const ToggleButton = ({ active, onClick, icon, label }) => (
  <button
    type="button"
    onClick={onClick}
    className={[
      "grid h-10 w-10 place-items-center rounded-lg border transition",
      active ? "bg-[#d8b05a] text-black border-[#d8b05a]" : "bg-white/5 text-white/60 border-white/10 hover:bg-white/10",
    ].join(" ")}
    aria-label={label}
    title={label}
  >
    <Icon name={icon} className="h-5 w-5" />
  </button>
);

export const Stat = ({ icon, label, value }) => (
  <div className="flex flex-col items-center gap-2">
    <div className="grid h-10 w-10 place-items-center rounded-xl border border-white/10 bg-white/5 text-[#d8b05a]/90">
      <Icon name={icon} />
    </div>
    <div className="text-[10px] tracking-[0.28em] text-white/30">{label}</div>
    <div className="text-sm font-semibold text-white/75">{value}</div>
  </div>
);

export const FleetCard = ({ jet, view = "grid", onRequest }) => {
  const isList = view === "list";

  return (
    <div
      className={[
        "relative overflow-hidden rounded-3xl border border-white/10 bg-[#1E1A14]"
      ].join(" ")}
    >
      {/* <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(90%_120%_at_0%_0%,rgba(216,176,90,0.14),transparent_60%)]" />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/0 via-white/0 to-black/45" /> */}

      <div className={["relative", isList ? "p-4 sm:p-5" : ""].join(" ")}>
        <div className={isList ? "flex flex-col gap-4 sm:flex-row sm:items-stretch" : ""}>
          {/* Image */}
          <div
            className={[
              "relative overflow-hidden",
              isList ? "rounded-2xl sm:w-[280px] sm:min-w-[280px]" : "rounded-t-3xl",
            ].join(" ")}
          >
            <img
              src={jet.gallery[0]}
              alt={jet.aircraft_name}
              className={[
                "w-full object-cover",
                isList ? "h-44 sm:h-full" : "h-48 sm:h-52 md:h-56",
              ].join(" ")}
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-black/0" />
            <div className="absolute right-4 top-4">
              <GoldPill>{jet.base_airport_iata}{" "}{jet.base_airport_city}</GoldPill>
            </div>
          </div>

          {/* Content */}
          <div className={isList ? "flex-1" : "p-5 sm:p-6"}>
            {/* Title */}
            <div className="mt-1">
              <div className="text-xl font-semibold text-white/90">{jet.aircraft_name}</div>
              <div className="mt-1 text-sm text-[#d8b05a]/75">{jet.subtitle}</div>
            </div>

            <div className="mt-4 h-px w-full bg-white/10" />

            {/* Stats */}
            <div className={["mt-5 grid gap-4", isList ? "grid-cols-3" : "grid-cols-3"].join(" ")}>
              <Stat icon="pin" label="RANGE" value={jet.aircraft_range} />
              <Stat icon="users" label="SEATS" value={jet.aircraft_seats} />
              <Stat icon="bag" label="BAGGAGE" value={jet.aircraft_baggage} />
            </div>

            <div className="mt-5 h-px w-full bg-white/10" />

            {/* Footer */}
            <div className={["mt-5 flex items-end justify-between gap-4", isList ? "flex-col sm:flex-row sm:items-center" : ""].join(" ")}>
              <div className="w-full sm:w-auto">
                <div className="text-[10px] tracking-[0.28em] text-white/40">EST. QUOTE</div>
                <div className="mt-1 flex items-end gap-2">
                  <div className="text-2xl lg:text-3xl font-semibold text-[#d8b05a]">{jet.quote}</div>
                </div>
              </div>

              <button
                type="button"
                onClick={() => onRequest?.(jet)}
                className={[
                  "h-12 w-full sm:w-auto rounded-xl px-6 text-xs font-semibold tracking-widest transition",
                  "bg-[#d8b05a] text-black hover:brightness-110 active:brightness-95",
                  "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/20",
                ].join(" ")}
              >
                REQUEST QUOTE
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Tab = ({ active, children, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={[
      "relative pb-3 text-md font-medium transition",
      active ? "text-[#d8b05a]" : "text-white/60 hover:text-white/80",
    ].join(" ")}
  >
    {children}
    {active && <span className="absolute -bottom-[1px] left-0 h-[2px] w-full bg-[#d8b05a]" />}
  </button>
);

export const StatusPill = ({ status }) => {
  const isApproved = status === "APPROVED";
  return (
    <span
      className={[
        "inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold",
        isApproved
          ? "bg-emerald-500/20 text-emerald-300"
          : "bg-slate-500/20 text-slate-300",
      ].join(" ")}
    >
      <span className={isApproved ? "text-emerald-300" : "text-slate-300"}>
        <Icon name="dot" className="h-2.5 w-2.5" />
      </span>
      {status}
    </span>
  );
};

export const ActionLink = ({ children, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="text-sm font-semibold text-[#d8b05a]/90 hover:underline"
  >
    {children}
  </button>
);

export const PagerBtn = ({ active, children, onClick, icon }) => (
  <button
    type="button"
    onClick={onClick}
    className={[
      "grid h-9 w-9 place-items-center rounded-lg border text-sm transition",
      active
        ? "bg-[#d8b05a] text-black border-[#d8b05a]"
        : "border-white/10 bg-white/5 text-white/60 hover:bg-white/10",
    ].join(" ")}
    aria-label={typeof children === "string" ? children : "page"}
  >
    {icon ? <Icon name={icon} /> : children}
  </button>
);

export const SectionTitle = ({ icon, title }) => (
  <div className="flex items-center gap-3">
    <span className="text-[#d8b05a]">
      <Icon name={icon} />
    </span>
    <h2 className="text-lg font-semibold text-white/90">{title}</h2>
  </div>
);

export const Pill = ({ children }) => (
  <span className="inline-flex items-center rounded-lg border border-white/10 bg-white/5 px-3 py-1 text-sm font-semibold text-[#d8b05a]">
    {children}
  </span>
);
export const CardShell = ({ children }) => (
  <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#2E281F]/40">
    <div className="relative">{children}</div>
  </div>
);